module.exports = __webpack_public_path__ + "img/2x UHF-PS1 & 3x BS-PD.4076ecc4.svg";